import React,{useState,useEffect} from "react";
//import StudentTopMenu from "./studenttopmenu";
import { useParams } from "react-router-dom";
//import StudentInfoBox from "./studentinfobox";
//import GlobalStudentLessonEdit from "../../pages/common/globalstudentlessoneditforgrade"
import { useAuth } from "../../../usercontext";
import {getIdData } from "../../../lib/studentinfo"
import Student911TopMenu from "../studentInfo/student911topmenu"
import GlobalStudentLessonEdit2 from "../../pages/common/globalStudentLessonEdit2";

export default function InstructorStudentLessonEdit() {
  const [studentClass, setStudentClass] = useState();
  const { profile, setProfile } = useAuth();
  let {  slug,status } = useParams();



  async function GetData() {
    const info = await getIdData(slug);
    console.log("info",info);
    
    if(info)
    setStudentClass(info[0].class);
  }

useEffect(() => {
  GetData();
}, [])

  return (
    <>
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <Student911TopMenu slug={slug} activeMenu={"GradeList"} />
            {studentClass && (
              // <GlobalStudentLessonEdit studentId={slug} status={status} studentClass={studentClass}/>
              <GlobalStudentLessonEdit2 studentId={slug} status={status} studentClass={studentClass}/>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
